<template>
  <div class="titleBox">
    <span class="title-color-box"></span>
    <span class="tips" :style="styleObj ? styleObj : ''">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    styleTitleObj: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    styleObj() {
      return this.styleTitleObj ? this.styleTitleObj : {};
    },
  },
};
</script>

<style lang="scss" scoped>
.titleBox {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .title-color-box {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: $theme-color;
    opacity: 1;
    margin-right: 8px;
    border-radius: 1px;
  }
  .tips {
    color: #333333;
    font-size: 12px !important;
    line-height: 17px;
    font-weight: 600;
  }
  .desc {
    color: #666666;
    margin-left: 8px;
    font-size: 12px;
  }
}
</style>
